import TooltipFor3dMap from './TooltipFor3dMap';

export default TooltipFor3dMap;
